import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

/**
 * 탭 아이콘. 전부 24 격자에 같은 선 굵기(1.9)로 그려 한 벌로 보이게 한다.
 *
 * 선택 상태는 색이 아니라 **채움**으로 구분한다. 색만 바꾸면 작은 크기에서 잘 안 읽힌다.
 * 모양은 이 앱의 말을 쓴다 — 홈은 집이 아니라 가격표, AI 는 반짝임, 조건은 저울.
 */
type Props = { color: string; focused: boolean; size?: number };

const W = 1.9;

export function TabHome({ color, focused, size = 24 }: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9.6 2.9h9.4a2.1 2.1 0 0 1 2.1 2.1v9.4a2.1 2.1 0 0 1-.6 1.5l-6.6 6.6a2.1 2.1 0 0 1-3 0l-7.8-7.8a2.1 2.1 0 0 1 0-3l6.6-6.6a2.1 2.1 0 0 1 1.5-.6z"
        stroke={color}
        strokeWidth={W}
        fill={focused ? color : 'none'}
        strokeLinejoin="round"
      />
      <Circle cx="16.8" cy="7.2" r="1.7" fill={focused ? '#FFFFFF' : color} />
    </Svg>
  );
}

export function TabSearch({ color, focused, size = 24 }: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9.4 2.6l1.5 4.1 4.1 1.5-4.1 1.5-1.5 4.1-1.5-4.1L3.8 8.2l4.1-1.5z"
        stroke={color}
        strokeWidth={W}
        fill={focused ? color : 'none'}
        strokeLinejoin="round"
      />
      <Path
        d="M17.4 13.1l.85 2.35 2.35.85-2.35.85-.85 2.35-.85-2.35-2.35-.85 2.35-.85z"
        stroke={color}
        strokeWidth={W}
        fill={focused ? color : 'none'}
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export function TabAlerts({ color, focused, size = 24 }: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M12 3a6.2 6.2 0 0 1 6.2 6.2v4.3l1.7 2.6a1 1 0 0 1-.85 1.55H5a1 1 0 0 1-.85-1.55l1.7-2.6V9.2A6.2 6.2 0 0 1 12 3z"
        stroke={color}
        strokeWidth={W}
        fill={focused ? color : 'none'}
        strokeLinejoin="round"
      />
      <Path d="M9.6 20a2.6 2.6 0 0 0 4.8 0" stroke={color} strokeWidth={W} strokeLinecap="round" fill="none" />
    </Svg>
  );
}

export function TabConditions({ color, focused, size = 24 }: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path d="M4 7.5h16M4 16.5h16" stroke={color} strokeWidth={W} strokeLinecap="round" />
      <Circle cx="9.2" cy="7.5" r="2.8" stroke={color} strokeWidth={W} fill={focused ? color : '#FFFFFF'} />
      <Circle cx="15.4" cy="16.5" r="2.8" stroke={color} strokeWidth={W} fill={focused ? color : '#FFFFFF'} />
    </Svg>
  );
}

export function TabMe({ color, focused, size = 24 }: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Circle cx="12" cy="8.2" r="3.9" stroke={color} strokeWidth={W} fill={focused ? color : 'none'} />
      <Path
        d="M4.6 20.4c0-3.9 3.3-6.4 7.4-6.4s7.4 2.5 7.4 6.4"
        stroke={color}
        strokeWidth={W}
        strokeLinecap="round"
        fill={focused ? color : 'none'}
      />
    </Svg>
  );
}
